import {
  MANUFACTURERS_CLEAR_ENTITIES,
  MANUFACTURERS_CREATE_ENTITY,
  MANUFACTURERS_DELETE_ENTITY,
  MANUFACTURERS_EDIT_ENTITY,
  MANUFACTURERS_FETCH_ALL_ENTITIES,
  MANUFACTURERS_FETCH_ENTITIES,
  MANUFACTURERS_FETCH_ENTITIES_CATALOG,
  MANUFACTURERS_SET_PAGE,
  MANUFACTURERS_SET_ROWS_PER_PAGE,
} from '../action-types/manufacturers-types';
import { axiosAction } from '../../utils/axiosAction';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_MANUFACTURERS}`;

export const setRowsPerPageAction = payload => ({
  type: MANUFACTURERS_SET_ROWS_PER_PAGE,
  payload,
});

export const setPageAction = payload => ({
  type: MANUFACTURERS_SET_PAGE,
  payload,
});
export const clearEntities = () => ({
  type: MANUFACTURERS_CLEAR_ENTITIES,
});

export const createEntity = entityObject => async dispatch => {
  return axiosAction.post(
    ENDPOINT,
    MANUFACTURERS_CREATE_ENTITY,
    dispatch,
    entityObject,
  );
};

export const editEntity = entityObjectId => async dispatch => {
  const { status, id } = entityObjectId;
  const endpoint = `${ENDPOINT}/${id}`;
  return axiosAction.put(endpoint, MANUFACTURERS_EDIT_ENTITY, dispatch, {
    status,
  });
};

export const deleteEntity = id => async dispatch => {
  const endpoint = `${ENDPOINT}/${id}`;
  return axiosAction.delete(endpoint, MANUFACTURERS_DELETE_ENTITY, dispatch);
};

export const getEntities =
  (params = {}) =>
  async dispatch => {
    return axiosAction.get(ENDPOINT, MANUFACTURERS_FETCH_ENTITIES, dispatch, {
      params,
    });
  };
export const getAllEntitiesCatalog = (params, meta?) => async dispatch => {
  return axiosAction.getAll(
    ENDPOINT,
    MANUFACTURERS_FETCH_ALL_ENTITIES,
    dispatch,
    params,
    { meta },
  );
};
export const getEntitiesCatalog =
  (params = {}) =>
  async dispatch => {
    return axiosAction.get(
      ENDPOINT,
      MANUFACTURERS_FETCH_ENTITIES_CATALOG,
      dispatch,
      { params },
    );
  };
